import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberMenuButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberMenuButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarSource"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"isAaMastered"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberMenuButton","document":MemberMenuButtonDocument}} as const;
export type MemberMenuButtonQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type MemberMenuButtonQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'avatarSource' | 'confirmed' | 'email' | 'fullName' | 'id' | 'idEnterprise' | 'isAaMastered' | 'oneTimeMessagesDismissed' | 'username'>
  )> }
);




/**
 * __useMemberMenuButtonQuery__
 *
 * To run a query within a React component, call `useMemberMenuButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberMenuButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberMenuButtonQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberMenuButtonQuery(baseOptions: Apollo.QueryHookOptions<MemberMenuButtonQuery, MemberMenuButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberMenuButtonQuery, MemberMenuButtonQueryVariables>(MemberMenuButtonDocument, options);
      }
export function useMemberMenuButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberMenuButtonQuery, MemberMenuButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberMenuButtonQuery, MemberMenuButtonQueryVariables>(MemberMenuButtonDocument, options);
        }
export type MemberMenuButtonQueryHookResult = ReturnType<typeof useMemberMenuButtonQuery>;
export type MemberMenuButtonLazyQueryHookResult = ReturnType<typeof useMemberMenuButtonLazyQuery>;
export type MemberMenuButtonQueryResult = Apollo.QueryResult<MemberMenuButtonQuery, MemberMenuButtonQueryVariables>;